/**
 * @fileoverview Branches field and profile toggle for the Location section.
 */

import React from "react";
import { IconButton } from "@mui/material";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import styles from "./Location.module.css";
import {
  CURSOR_NOT_ALLOWED,
  SHOW_IN_PROFILE_KEY,
  TOGGLE_COLOR_ACTIVE,
  TOGGLE_COLOR_INACTIVE,
} from "./locationConstants";

const LocationBranchesField = ({ model, t }) => {
  const {
    getFieldValidationState, getErrorMessage,
    handleInputChange, handleFieldChange,
    handleToggleChange, sucursales,
    setSucursales, mostrarSucursales,
    setMostrarSucursales,
  } = model;

  return (
    <div className={`${styles.inputGroup} ${styles.twoLabelsGroup}`}>
      <label className={styles.inputLabel}>
        {t("components.location.branchesLabel")}
      </label>
      <input
        type="text"
        className={`${styles.input} ${styles.tabletBranchesInput} ${
          getFieldValidationState("sucursales", sucursales) === "error"
            ? styles.inputError
            : ""
        }`}
        disabled={true}
        placeholder={t("components.location.branchesPlaceholder")}
        onChange={(e) => {
          const value = e.target.value;
          setSucursales(value);
          handleFieldChange("sucursales", value);
          handleInputChange("sucursales", value);
        }}
        value={sucursales}
        maxLength={300}
        style={{ cursor: CURSOR_NOT_ALLOWED }}
      />
      {getErrorMessage("sucursales") && (
        <p className={styles.errorMessage}>
          {getErrorMessage("sucursales")}
        </p>
      )}
      <div
        className={`${styles.showInProfileContainer} ${styles.lastShowInProfileContainer}`}
      >
        <span className={styles.showInProfileText}>
          {t(SHOW_IN_PROFILE_KEY)}
        </span>
        <IconButton
          onClick={() => {
            setMostrarSucursales(!mostrarSucursales);
            handleToggleChange("mostrarSucursales", !mostrarSucursales);
          }}
          size="small"
          className={styles.toggleButton}
          sx={{
            "& .MuiSvgIcon-root": {
              color: mostrarSucursales
                ? TOGGLE_COLOR_ACTIVE
                : TOGGLE_COLOR_INACTIVE,
            },
          }}
        >
          {mostrarSucursales ? <ToggleOnIcon /> : <ToggleOffIcon />}
        </IconButton>
      </div>
    </div>
  );
};

export default LocationBranchesField;
